import fetchAllProductData from '../../src/client/models/product/fetch-all-product-data';
import Page from '../../src/client/pages/youth-discount';
import withLoadData from '../../src/client/routes/components/with-load-data';

// @ts-expect-error - Automatic, Please fix when editing this file
const YouthPage = (props) => withLoadData(Page, fetchAllProductData)({ ...props });

export default YouthPage;
